<template>
  <div class="rent--datepicker">
    <v-date-picker
        v-model="query.range"
        mode="date"
        :masks="masks"
        :min-date='new Date()'
        :select-attribute="attributes"
        :drag-attribute="attributes"
        :model-config="modelConfig"
        :is-range="true"
        :columns="$screens({ default: 1, md: 2 })"
        :is-expanded="$screens({ default: true, md: false })"
    >
      <template v-slot="{ inputValue, inputEvents, isDragging }">
        <div class="rent--datepicker-wrap">
          <div class="rent--datepicker-input-wrap">
            <div class="rent--datepicker-label">{{ $store.getters.language.from }}</div>
            <input
                :placeholder=$store.getters.language.add_dates
                :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                :value="inputValue.start"
                v-on="inputEvents.start"
            />
          </div>
          <div class="rent--datepicker-input-wrap">
            <div class="rent--datepicker-label">{{ $store.getters.language.to }}</div>
            <input
                :placeholder=$store.getters.language.add_dates
                :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                :value="inputValue.end"
                v-on="inputEvents.end"
            />
          </div>
        </div>
      </template>
    </v-date-picker>
  </div>
</template>

<script>

    export default {
  name: 'DatePicker',
  data: () => ({
    query: {
      range: {
        start: "",
        end: ""
      }
    },
    masks: {
      input: 'DD MMMM',
      output: 'YYYY-MM-DD'
    },
    modelConfig: {
      type: 'string',
      mask: 'DD-MM-YYYY' // Uses 'iso' if missing
    },
    attributes: {
      highlight: {
        start: {
          style: {
            backgroundColor: '#000000' // black
          },
          contentStyle: {
            color: '#ffffff' // color of the text
          }
        },
        base: {
          style: {
            backgroundColor: '#F3F1F0' // light grey
          }
        },
        end: {
          style: {
            backgroundColor: '#000000' // black
          },
          contentStyle: {
            color: '#ffffff' // color of the text
          }
        }
      }
    }
  }),
  props: ['data'],
  watch: {
    query: {
      handler (value) {
        this.$store.commit('from_date', this.query.range.start)
        this.$store.commit('to_date', this.query.range.end)
      },
      deep: true,
      immediate: true
    }
  },
  components: {
  },
  computed: {
  },
  mounted () {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../scss/global/includes";

.rent--datepicker {
  z-index: 1004;
  position: relative;
  padding: 20px;
  input {
    border: 0;
    width: 100%;
    font-size: 16px;
  }
  input {
    @include placeholder {
      color: $placeholder;
    }
  }
}
.rent--datepicker-wrap {
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 1fr 1fr;
}
.rent--datepicker-label {
  font-size: 12px;
  position: absolute;
  top: -12px;
  left: 0;
}
.rent--datepicker-input-wrap {
  position: relative;
}

.vc-popover-content-wrapper {
  .vc-popover-content {
    box-shadow: rgba(0,0,0, 0.2) 0 6px 20px !important;
    border: 0;
  }
  .vc-weekday {
    color: $strong-light !important;
    font-size: 12px !important;
  }
  .vc-day-content.is-disabled {
    color: $mid-light !important;
  }
  .vc-day {
    padding: 10px;
  }
  .vc-header {
    padding: 20px 18px;
  }
  .vc-arrows-container {
    padding: 20px 10px;
  }
  .vc-pane {
    padding: 20px;
    @include breakpoint(tablet) {
      padding: 0;
    }
  }
  .vc-popover-caret {
    display: none;
  }
}
</style>
